import styles from './style.module.css';
import Modal from 'react-responsive-modal';

interface IModalHasFailed {
  modalIsOpen: boolean;
  toggleModal: () => void;
  tryAgain: () => void;
  cancelAnswer: () => void;
}

export function ModalHasFailed({
  modalIsOpen,
  toggleModal,
  tryAgain,
  cancelAnswer,
}: IModalHasFailed) {
  return (
    <Modal
      open={modalIsOpen}
      onClose={() => {
        toggleModal();
      }}
      center
    >
      <div className={styles.contents}>
        <div className="d-flex justify-content-center">
          <img
            className={styles.alert}
            src={
              'https://oq-email-assets.s3.us-east-1.amazonaws.com/icons/mysteryBox.png'
            }
            alt=""
          />
        </div>
        <h1 className={styles.title}>
          <b className={styles.highlightText}>OPS!</b> Você não atingiu o mínimo
          de respostas corretas para pontuar! Tentar novamente!
        </h1>
      </div>
      <div className={styles.contentBtn}>
        <button
          onClick={() => {
            toggleModal();
            tryAgain();
          }}
          className={styles.btnAgree}
          type="button"
        >
          Responder de novo
        </button>
        <button
          onClick={() => {
            toggleModal();
            cancelAnswer();
          }}
          className={styles.btnBack}
          type="button"
        >
          Responder depois
        </button>
      </div>
    </Modal>
  );
}
